var map = {
	"./COPD-home-monitoring.png": 36091,
	"./brand/brand-shape-1.png": 59241,
	"./brand/brand-shape-2.png": 34305,
	"./brand/brand-shape-3.png": 19945,
	"./chrome.png": 36731,
	"./flags.png": 40414,
	"./logo-bigpicture-poweredby-negative.svg": 49984,
	"./logo-bigpicture-poweredby.svg": 53181,
	"./logo-bigpicture-storybook.svg": 98854,
	"./logo-bigpicture-text.svg": 56957,
	"./map-pattern-a.png": 2719,
	"./map-pattern-b.png": 11563,
	"./menicon/conjunctival-hyperemia-0.jpg": 61302,
	"./menicon/conjunctival-hyperemia-1.jpg": 54539,
	"./menicon/conjunctival-hyperemia-2.jpg": 69079,
	"./menicon/conjunctival-hyperemia-3.jpg": 65455,
	"./menicon/conjunctival-hyperemia-4.jpg": 59493,
	"./menicon/corneal-infiltrates-0.jpg": 87754,
	"./menicon/corneal-infiltrates-1.jpg": 90105,
	"./menicon/corneal-infiltrates-2.jpg": 20780,
	"./menicon/corneal-infiltrates-3.jpg": 29147,
	"./menicon/corneal-infiltrates-4.jpg": 5692,
	"./menicon/corneal-neovascularisation-0.jpg": 45950,
	"./menicon/corneal-neovascularisation-1.jpg": 1142,
	"./menicon/corneal-neovascularisation-2.jpg": 60702,
	"./menicon/corneal-neovascularisation-3.jpg": 57405,
	"./menicon/corneal-neovascularisation-4.jpg": 13393,
	"./menicon/corneal-staining-0.jpg": 21156,
	"./menicon/corneal-staining-1.jpg": 99686,
	"./menicon/corneal-staining-2.jpg": 22274,
	"./menicon/corneal-staining-3.jpg": 91877,
	"./menicon/corneal-staining-4.jpg": 27161,
	"./menicon/lens-collection-contact-lens-coverage.jpg": 75260,
	"./menicon/papillary-reaction-0.jpg": 10907,
	"./menicon/papillary-reaction-1.jpg": 67231,
	"./menicon/papillary-reaction-2.jpg": 4478,
	"./menicon/papillary-reaction-3.jpg": 1393,
	"./menicon/papillary-reaction-4.jpg": 5728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92550;